import styled from 'styled-components6';
import { useMapContext } from '../../hooks/MapProvider';
import { ServiceAreaStats } from './ServiceAreaStats';
import { useBreakpoint } from '../../providers';
import { LocationTitle } from './LocationTitle';
import { Else, If, Then, When } from 'react-if';
import { HorizontalDivider } from '../../components';
import { NeighborhoodStatus, usePostCode } from '../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

const BannerContainer = styled.div`
    display: flex;
    align-items: center;
    height: 86px;
`;

export const NeighborhoodOverviewBanner = (): JSX.Element => {
    const { neighborhood, neighborhoodStatus } = useMapContext();
    const { isAboveBreakpoint, isBelowBreakpoint } = useBreakpoint();
    const postCode = usePostCode();

    return (
        <If condition={neighborhood?.jobCount || neighborhood?.reviewCount}>
            <Then>
                <BannerContainer
                    style={{
                        flexDirection: isBelowBreakpoint('sm')
                            ? 'column'
                            : 'row',
                        justifyContent: isBelowBreakpoint('sm')
                            ? 'center'
                            : 'space-between',
                    }}
                >
                    <When condition={isAboveBreakpoint('sm')}>
                        <LocationTitle />
                    </When>
                    <ServiceAreaStats neighborhood={neighborhood} />
                </BannerContainer>
                <HorizontalDivider />
            </Then>
            <Else>
                <When
                    condition={
                        neighborhoodStatus === NeighborhoodStatus.NOT_FOUND
                    }
                >
                    <EmptyNeighborhoodBanner
                        postCode={postCode}
                        neighborhood={neighborhood?.neighborhood}
                    />
                </When>
            </Else>
        </If>
    );
};

const EmptyNeighborhoodBannerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--rwl-palette-lightBlue-100);
    border-radius: var(--rwl-radius-xs);
    padding: var(--rwl-spacing-md) var(--rwl-spacing-lg);
    margin-top: var(--rwl-spacing-lg);
    gap: var(--rwl-spacing-md);
    color: var(--rwl-palette-blue-900);
`;

const SVGContainer = styled.div`
    height: 100%;
    align-items: center;
    display: flex;
`;

const TextContainer = styled.div`
    align-items: center;
    text-align: left;
    flex: 1;
`;
const EmptyNeighborhoodBanner = ({
    neighborhood,
    postCode,
}: {
    neighborhood?: string;
    postCode?: string;
}): JSX.Element => {
    const selectedArea = postCode || neighborhood || 'selected';
    const selectedAreaPhrase = postCode ? 'zip code' : 'neighborhood';
    return (
        <EmptyNeighborhoodBannerContainer>
            <SVGContainer>
                <FontAwesomeIcon icon={faInfoCircle} color="#0288D1" />
            </SVGContainer>
            <TextContainer>
                We don’t have any projects in the <b>{selectedArea}</b>{' '}
                {selectedAreaPhrase} yet, but feel free to browse our featured
                projects below.
            </TextContainer>
        </EmptyNeighborhoodBannerContainer>
    );
};
